import { render, staticRenderFns } from "./ClaimExpiration.vue?vue&type=template&id=f5e01374&scoped=true&"
import script from "./ClaimExpiration.vue?vue&type=script&lang=js&"
export * from "./ClaimExpiration.vue?vue&type=script&lang=js&"
import style0 from "./ClaimExpiration.vue?vue&type=style&index=0&id=f5e01374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e01374",
  null
  
)

export default component.exports